const doc = [({"da":({"js":({"admin":({"sending_rules":({"table":({"the_sending_rule_was_deleted":"Udsendingsreglen blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;